import React, { useState } from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import RouteSearch from '../RouteSearch';
import Label from '../ATSearch/Label';
import { getTimetablesUrlParams } from '../../utils/UrlGenerator';
import * as Icons from '../Icons';
import ChoiceChip from '../ChoiceChip/ChoiceChip';
import TimetablesInfoCard from './TimetablesInfoCard';
import { TRAIN_TIMETABLES_INFO_CARD } from '../../constants/timetablesInfoCardContent';

const transportModes = [
  {
    id: 'bus',
    title: 'Bus',
    icon: Icons.Bus,
    text: 'Bus or route number',
    placeholder: 'e.g. 161 or New Lynn',
    mode: '3',
  },
  {
    id: 'train',
    title: 'Train',
    icon: Icons.Train,
    text: 'Train line or destination',
    placeholder: 'e.g. South or Waitematā',
    mode: '2',
  },
  {
    id: 'ferry',
    title: 'Ferry',
    icon: Icons.Ferry,
    text: 'Ferry route or destination',
    placeholder: 'e.g. Half moon bay',
    mode: '4',
  },
];

export default function Timetables({ ttUrl, dtUrl }) {
  const [currentTab, setCurrentTab] = useState(transportModes[0]);

  const gotoTimetablesPage = (route) => {
    if (route) {
      window.location.href = `${ttUrl}?${getTimetablesUrlParams(route, currentTab.id.toUpperCase())}`;
    }
  };

  function SearchInput(props) {
    /*
     * TODO: remove the text state since parent didn't use it to do anything, this requires RouteSearch
     * to use the Search component in a non-controlled mode.
     */
    const [text, setText] = useState('');
    return (
      <Label htmlFor="tt-route-search-input" className="route-input-label at-font__headline6" text={props.text} showError={false} errorText={`Enter a ${props.text.toLowerCase()}`} >
        <RouteSearch
          id="tt-route-search-input"
          storageKey="TimetableRoutes-recent"
          routeType={props.mode}
          placeholder={props.placeholder}
          onRouteDetermined={gotoTimetablesPage}
          onTextChange={setText}
          value={text}
          className="tt-route-search"
        />
      </Label>
    );
  }
  // As long as mode don't change the Content shouldn't rerender(input text shouldn't update the Timetable overall)
  const Content = React.memo(SearchInput, (prevProps, nextProps) => prevProps.mode === nextProps.mode);

  const switchTab = (tab) => {
    setCurrentTab(find(transportModes, ['id', tab]));
  };

  return (
    <>
      <div className={`at-d-flex at-flex-wrap at-gap-2 ${currentTab.id === 'train' ? '' : 'at-mb-6'}`}>
        {
            transportModes.map((transportMode) => {
              const isActive = transportMode.id === currentTab.id;

              return (
                <ChoiceChip
                  key={transportMode.id}
                  label={transportMode.title}
                  value={transportMode.id}
                  isActive={isActive}
                  onValueSelected={switchTab}
                />
              );
            })
          }
      </div>
      {currentTab.id === 'train'
        ? (
          <div className="at-subgrid at-sm:col-span-6 at-md:col-span-6 at-lg:col-span-12 at-xl:col-span-12 at-gap-7 at-mt-md-6 at-mt-4">
            <TimetablesInfoCard {...TRAIN_TIMETABLES_INFO_CARD} url={dtUrl} />
          </div>
        )
        : <Content {...currentTab} />}
    </>
  );
}

Timetables.defaultProps = {
  placeholder: '',
};

Timetables.propTypes = {
  ttUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(URL)]).isRequired,
  dtUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(URL)]).isRequired,
  placeholder: PropTypes.string,
};
